// Documentation only: these strings are displayed, never executed by PRIsME.
export const mayaCommands: Record<number, { title: string; code: string }[]> = {
  1: [
    { title: 'Bash — profil confirmé et sauvegarde privée (même terminal pour toutes les étapes)', code: String.raw`set -euo pipefail
set +x
umask 077
export HERMES_HOME="${'$'}{HERMES_HOME:-$HOME/.hermes}"
# Confirmer ce chemin avec le responsable du service AVANT de continuer.
printf 'Profil ciblé : %s\n' "$HERMES_HOME"
command -v hermes
hermes config set --help
# Utiliser le Python du venv Hermes si python3 ne possède pas ces modules.
python3 -c 'import yaml, dotenv'
test -f "$HERMES_HOME/config.yaml"
export MAYA_BACKUP="$(mktemp -d "$HERMES_HOME/maya-backup.XXXXXXXX")"
chmod 700 "$MAYA_BACKUP"
cp "$HERMES_HOME/config.yaml" "$MAYA_BACKUP/config.yaml"
if [ -f "$HERMES_HOME/.env" ]; then
  cp "$HERMES_HOME/.env" "$MAYA_BACKUP/.env"
else
  touch "$MAYA_BACKUP/env-was-absent"
fi
chmod 600 "$MAYA_BACKUP"/* "$MAYA_BACKUP"/.env 2>/dev/null || true
printf 'Sauvegarde privée : %s\n' "$MAYA_BACKUP"` },
    { title: 'Saisie humaine masquée — aucun secret dans le chat, les arguments ou les journaux', code: String.raw`python3 - <<'PY'
import getpass, io, os, tempfile, warnings
from pathlib import Path
from dotenv import dotenv_values
from dotenv.parser import parse_stream
warnings.simplefilter('error', getpass.GetPassWarning)
p = Path(os.environ['HERMES_HOME']) / '.env'
if p.is_symlink():
    raise SystemExit('Arrêt : .env est un lien symbolique; faire valider le stockage.')
text = p.read_text() if p.exists() else ''
# Le parseur conserve les autres variables, commentaires et valeurs multilignes.
parts = list(parse_stream(io.StringIO(text)))
if any(part.error for part in parts):
    raise SystemExit('Arrêt : syntaxe .env invalide; aucune modification.')
current = dotenv_values(stream=io.StringIO(text), interpolate=False).get('AYA_API_KEY')
key = current or getpass.getpass('AYA_API_KEY (saisie masquée, terminal local) : ')
if not key or any(c in key for c in '\r\n\x00'):
    raise SystemExit('Arrêt : clé vide ou multiligne.')
# Retirer TOUTES les anciennes affectations, puis écrire une seule valeur citée.
kept = ''.join(part.original.string for part in parts if part.key != 'AYA_API_KEY')
quoted = key.replace('\\', '\\\\').replace("'", "\\'")
updated = kept.rstrip('\n') + "\nAYA_API_KEY='" + quoted + "'\n"
fd, name = tempfile.mkstemp(prefix='.maya-env-', dir=p.parent)
try:
    with os.fdopen(fd, 'w') as out:
        out.write(updated)
    os.chmod(name, 0o600)
    os.replace(name, p)
finally:
    if os.path.exists(name):
        os.unlink(name)
values = dotenv_values(p, interpolate=False)
assert values.get('AYA_API_KEY') == key
assert sum(part.key == 'AYA_API_KEY' for part in parse_stream(io.StringIO(p.read_text()))) == 1
print('AYA_API_KEY : présente; affectation unique; permissions 600. Valeur non affichée.')
PY
# Éviter qu’une ancienne variable héritée supplante le fichier privé.
unset AYA_API_KEY` },
  ],
  2: [
    { title: 'Fournisseur CLI — aucune commande model.default ou model.provider', code: String.raw`hermes config set providers.maya.api https://maya-api.bzinc.ai/v1
hermes config set providers.maya.key_env AYA_API_KEY
hermes config set providers.maya.transport chat_completions
hermes config set providers.maya.default_model Qwen/Qwen3.8-27B-FP8
hermes config set providers.maya.context_length 131072` },
    { title: 'Catalogue WebGUI — fusion idempotente, sans écraser les autres fournisseurs', code: String.raw`python3 - <<'PY'
import json, os, subprocess
from pathlib import Path
import yaml
p = Path(os.environ['HERMES_HOME']) / 'config.yaml'
cfg = yaml.safe_load(p.read_text()) or {}
entries = cfg.get('custom_providers', [])
if not isinstance(entries, list) or any(not isinstance(e, dict) for e in entries):
    raise SystemExit('Arrêt : custom_providers doit être une liste de dictionnaires.')
# Refuser de transporter un secret existant dans les arguments de config set.
def secrets(value):
    if isinstance(value, dict):
        return any((k.lower() in ('api_key', 'token', 'password', 'secret') and v)
                   or secrets(v) for k, v in value.items())
    return isinstance(value, list) and any(secrets(v) for v in value)
if secrets(entries):
    raise SystemExit('Arrêt : déplacer les secrets du catalogue vers .env avant la fusion.')
others = [e for e in entries if str(e.get('name', '')).strip().lower() != 'maya']
old = next((e for e in entries if str(e.get('name', '')).strip().lower() == 'maya'), {})
maya = {**old, 'name': 'maya', 'base_url': 'https://maya-api.bzinc.ai/v1',
        'key_env': 'AYA_API_KEY', 'model': 'Qwen/Qwen3.8-27B-FP8',
        'models': ['Qwen/Qwen3.8-27B-FP8'], 'context_length': 131072}
merged = others + [maya]
result = subprocess.run(['hermes', 'config', 'set', 'custom_providers', json.dumps(merged)],
                        capture_output=True, text=True)
if result.returncode:
    raise SystemExit('Échec config set custom_providers; arrêter et consulter localement sans diffuser de secrets.')
after = yaml.safe_load(p.read_text())
assert after['custom_providers'] == merged, 'Catalogue non enregistré'
assert after.get('model') == cfg.get('model'), 'Défaut modifié : arrêter'
print('Catalogue enregistré : une entrée maya; autres fournisseurs et défaut conservés.')
PY` },
    { title: 'Test CLI ciblé — obtenir une réponse réelle, sans changer Codex', code: String.raw`hermes chat --provider maya --model Qwen/Qwen3.8-27B-FP8 --oneshot -q 'Sans outil, réponds uniquement : MAYA_OK'` },
  ],
  4: [
    { title: 'Contrôles locaux sans divulgation', code: String.raw`python3 - <<'PY'
import os
from pathlib import Path
import yaml
from dotenv import dotenv_values
home = Path(os.environ['HERMES_HOME'])
cfg = yaml.safe_load((home / 'config.yaml').read_text())
before = yaml.safe_load((Path(os.environ['MAYA_BACKUP']) / 'config.yaml').read_text())
assert cfg.get('model') == before.get('model'), 'Défaut Codex modifié'
provider = cfg['providers']['maya']
for key, expected in {'api': 'https://maya-api.bzinc.ai/v1', 'key_env': 'AYA_API_KEY',
                      'transport': 'chat_completions', 'default_model': 'Qwen/Qwen3.8-27B-FP8',
                      'context_length': 131072}.items():
    assert provider.get(key) == expected, 'Paramètre fournisseur incorrect : ' + key
entries = [e for e in cfg['custom_providers'] if e.get('name') == 'maya']
assert len(entries) == 1, 'Maya absent ou dupliqué'
assert entries[0]['models'] == ['Qwen/Qwen3.8-27B-FP8']
assert dotenv_values(home / '.env', interpolate=False).get('AYA_API_KEY'), 'Clé absente'
print('Paramètres Maya et présence du secret vérifiés; défaut inchangé depuis la sauvegarde.')
PY` },
    { title: 'Retour arrière — seulement si aucune autre modification depuis la sauvegarde', code: String.raw`# Fermer les sessions de test. Si un tiers a modifié config.yaml ou .env,
# NE PAS restaurer tout le fichier : faire réconcilier uniquement Maya par le responsable.
# MAYA_BACKUP doit désigner la sauvegarde privée créée à l’étape 2.
test -n "$MAYA_BACKUP"
test -f "$MAYA_BACKUP/config.yaml"
cp "$MAYA_BACKUP/config.yaml" "$HERMES_HOME/config.yaml"
chmod 600 "$HERMES_HOME/config.yaml"
if [ -f "$MAYA_BACKUP/.env" ]; then
  cp "$MAYA_BACKUP/.env" "$HERMES_HOME/.env"
  chmod 600 "$HERMES_HOME/.env"
elif [ -f "$MAYA_BACKUP/env-was-absent" ]; then
  rm -f "$HERMES_HOME/.env"
else
  printf 'Sauvegarde .env incomplète : arrêter.\n' >&2
  exit 1
fi
cmp -s "$MAYA_BACKUP/config.yaml" "$HERMES_HOME/config.yaml"
if [ -f "$MAYA_BACKUP/.env" ]; then
  cmp -s "$MAYA_BACKUP/.env" "$HERMES_HOME/.env"
else
  test ! -e "$HERMES_HOME/.env"
fi
printf 'Fichiers restaurés et comparés sans afficher leur contenu.\n'` },
  ],
};
